import * as React from 'react';

import Modal from 'src/components/common/Modal';
import Alert from 'src/components/common/Alert';

import { isMobile } from 'src/utils/responsiveHelpers';
import ContactService from 'src/services/contact/ContactService';

import logo from 'src/assets/mainLogo';
import './FeedbackForm.scss';
import UserModel from 'src/model/user.model';

interface IFeedbackFormProps {
  onClose: () => void;
  userData: UserModel;
  onLoad: () => void;
  t?: any;
}

interface IFeedbackFormState {
  name: string;
  email: string;
  phone: string;
  comments: string;
  style: object;
  isMobile: boolean;
  submitted: boolean;
  showAlert: boolean;
  loading: boolean;
  accountNumber: string;
  webUserId: string;
  subjectLine: string;
}

class FeedbackForm extends React.Component<
  IFeedbackFormProps,
  IFeedbackFormState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      name: this.props?.userData?.name || '',
      email: '',
      phone: null,
      comments: '',
      style: {},
      isMobile: isMobile(),
      submitted: false,
      showAlert: false,
      loading: false,
      accountNumber:
        this.props.userData && this.props.userData.accountId
          ? this.props.userData.accountId
          : '',
      webUserId:
        this.props.userData && this.props.userData.sub
          ? this.props.userData.sub
          : '',
      subjectLine: ''
    };
  }

  public feedBackErrors: any;

  private handleNameChange = (name: string) => {
    this.setState({ name });
  };

  private handleEmailChange = (email: string) => {
    this.setState({ email });
  };

  private handlePhoneChange = (phone: string) => {
    this.setState({ phone });
  };

  private handleCommentsChange = (comments: string) => {
    this.setState({ comments });
  };

  private handleAccountNumberChange = (accountNumber: string) => {
    this.setState({ accountNumber });
  };

  private handleUserIdChange = (webUserId: string) => {
    this.setState({ webUserId });
  };

  private handleSubjectChange = (subjectLine: string) => {
    this.setState({ subjectLine });
  };

  private handleSubbmit = (event: any) => {
    this.ValidateForm();
    if (this.feedBackErrors.isFieldsRequiredError()) {
      this.setState({ loading: false });
      return;
    }
    this.setState({ loading: true }, () =>
      ContactService.sendFeedback(
        this.state.comments,
        this.state.email,
        this.state.name,
        this.state.phone,
        this.state.accountNumber,
        this.state.webUserId,
        this.state.subjectLine,
        'FEEDBACK'
      )
        .then(res => {
          console.log(res);
          this.setState({ submitted: true, loading: false });
        })
        .catch(err => {
          this.handleFormErrors(err);
          this.setState({ showAlert: true, loading: false });
        })
    );
  };

  private closeModal = () => {
    this.setState(
      {
        style: {
          display: 'none'
        }
      },
      () => {
        if (this.props.onClose) {
          this.props.onClose();
        }
      }
    );
  };

  public componentDidMount() {
    if (this.props.userData.accountId && !this.props.userData.name) {
      this.props.onLoad();
    }
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public componentDidUpdate(prevProps: IFeedbackFormProps) {
    if (this.props.userData !== prevProps.userData) {
      this.setState({ name: this.props.userData.name });
    }
  }

  public ValidateForm = () => {
    this.feedBackErrors = FeedBackFormErrors();
    this.feedBackErrors.nameRequiredError = !this.state.name ? true : false;
    this.feedBackErrors.emailRequiredError = !this.state.email ? true : false;
    if (this.props.userData.accountId) {
      this.feedBackErrors.accountNumberRequiredError = !this.state.accountNumber
        ? true
        : false;
    } else {
      this.feedBackErrors.accountNumberRequiredError = false;
    }
    this.feedBackErrors.commentsRequiredError = !this.state.comments
      ? true
      : false;
    this.feedBackErrors.subjectRequiredError = !this.state.subjectLine
      ? true
      : false;
  };

  public handleFormErrors(error: any) {
    try {
      this.feedBackErrors = FeedBackFormErrors();
      const { data } = error.response;
      if (data && data.message) {
        this.feedBackErrors.invalidEmailError = data.message.includes('email')
          ? true
          : false;
        this.feedBackErrors.invalidAccountNumberError = data.message.includes(
          'accountNumber'
        )
          ? true
          : false;
        this.feedBackErrors.invalidPhoneNumber = data.message.includes(
          'phoneNumber'
        )
          ? true
          : false;
      }
    } catch (error) {
      this.setState({ showAlert: true, loading: false });
    }
  }

  private renderFeedbackForm = () => {
    const { t } = this.props;
    return (
      <div className="rp-feedback-form--content">
        <span
          onClick={e => this.closeModal()}
          className="rpds-close rp-feedback-form--content--close-modal-icon"
        />
        <div
          className="rp-feedback-form--content-image-container"
          style={{
            backgroundImage: `url(${logo})`
          }}
        />
        <div className="rp-feedback-form--content-title">
          {t('feedbackForm.formTitile')}
        </div>
        {this.state.submitted ? this.renderThankYou() : this.renderForm()}
      </div>
    );
  };

  private renderForm() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div className="rp-feedback-form--alert">
          {this.state.showAlert && (
            <Alert
              styleClass="errorFeedbackAlert"
              message={t('feedbackForm.errorAlertTitle')}
              icon={'rpds-error'}
              handleCloseAlert={() => {
                return;
              }}
              type={'error'}
            />
          )}
        </div>
        <form className="rp-feedback-form--content-form">
          <label className="rp-feedback-form--content-form-label">
            {t('feedbackForm.accountNumber')}
            {this.props.userData.accountId ? '*' : ''}
          </label>
          <input
            className={
              this.feedBackErrors?.invalidAccountNumberError ||
              this.feedBackErrors?.accountNumberRequiredError
                ? 'rp-feedback-form--content-form-input rp-invalid-form-input-field'
                : 'rp-feedback-form--content-form-input'
            }
            type="text"
            value={this.state.accountNumber}
            onChange={e => this.handleAccountNumberChange(e.target.value)}
            required={
              this.props.userData && this.props.userData.accountId
                ? true
                : false
            }
            readOnly={
              this.props.userData && this.props.userData.accountId
                ? true
                : false
            }
          />
          {this.feedBackErrors?.accountNumberRequiredError ? (
            <React.Fragment>
              <div className="rp-input-error">
                {t('common.fieldRequiredTxt')}
              </div>
            </React.Fragment>
          ) : (
            ''
          )}
          {this.feedBackErrors?.invalidAccountNumberError ? (
            <React.Fragment>
              <div className="rp-input-error">
                {t('feedbackForm.invalidAccountNumber')}
              </div>
            </React.Fragment>
          ) : (
            ''
          )}

          <label className="rp-feedback-form--content-form-label">
            {t('feedbackForm.userId')}
          </label>
          <input
            className="rp-feedback-form--content-form-input"
            type="text"
            value={this.state.webUserId}
            onChange={e => this.handleUserIdChange(e.target.value)}
            required={true}
          />

          <label className="rp-feedback-form--content-form-label">
            {t('feedbackForm.name')}*
          </label>
          <input
            className={
              this.feedBackErrors?.nameRequiredError
                ? 'rp-feedback-form--content-form-input rp-invalid-form-input-field'
                : 'rp-feedback-form--content-form-input'
            }
            type="text"
            value={this.state.name}
            onChange={e => this.handleNameChange(e.target.value)}
            required={true}
          />
          {this.feedBackErrors?.nameRequiredError ? (
            <React.Fragment>
              <div className="rp-input-error">
                {t('common.fieldRequiredTxt')}
              </div>
            </React.Fragment>
          ) : (
            ''
          )}

          <label className="rp-feedback-form--content-form-label">
            {t('feedbackForm.subjectLine')}*{' '}
          </label>
          <input
            className={
              this.feedBackErrors?.subjectRequiredError
                ? 'rp-feedback-form--content-form-input rp-invalid-form-input-field'
                : 'rp-feedback-form--content-form-input'
            }
            type="email"
            value={this.state.subjectLine}
            onChange={e => this.handleSubjectChange(e.target.value)}
            required={true}
          />
          {this.feedBackErrors?.subjectRequiredError ? (
            <React.Fragment>
              <div className="rp-input-error">
                {t('common.fieldRequiredTxt')}
              </div>
            </React.Fragment>
          ) : (
            ''
          )}

          <label className="rp-feedback-form--content-form-label">
            {t('feedbackForm.email')}*{' '}
          </label>
          <input
            className={
              this.feedBackErrors?.emailRequiredError ||
              this.feedBackErrors?.invalidEmailError
                ? 'rp-feedback-form--content-form-input rp-invalid-form-input-field'
                : 'rp-feedback-form--content-form-input'
            }
            type="email"
            value={this.state.email}
            onChange={e => this.handleEmailChange(e.target.value)}
            required={true}
          />
          {this.feedBackErrors?.emailRequiredError ? (
            <React.Fragment>
              <div className="rp-input-error">
                {t('common.fieldRequiredTxt')}
              </div>
            </React.Fragment>
          ) : (
            ''
          )}
          {this.feedBackErrors?.invalidEmailError ? (
            <React.Fragment>
              <div className="rp-input-error">
                {t('feedbackForm.invalidEmailFormat')}
              </div>
            </React.Fragment>
          ) : (
            ''
          )}

          <label className="rp-feedback-form--content-form-label">
            {t('feedbackForm.phoneNumber')}
          </label>
          <input
            className={
              this.feedBackErrors?.invalidPhoneNumber
                ? 'rp-feedback-form--content-form-input rp-invalid-form-input-field'
                : 'rp-feedback-form--content-form-input'
            }
            type="tel"
            value={this.state.phone}
            onChange={e => this.handlePhoneChange(e.target.value)}
          />
          {this.feedBackErrors?.invalidPhoneNumber ? (
            <React.Fragment>
              <div className="rp-input-error">
                {t('feedbackForm.invalidphone')}
              </div>
            </React.Fragment>
          ) : (
            ''
          )}

          <label className="rp-feedback-form--content-form-label">
            {t('feedbackForm.comments')}*
          </label>
          <textarea
            className={
              this.feedBackErrors?.commentsRequiredError
                ? 'rp-feedback-form--content-form-textarea rp-invalid-form-input-field'
                : 'rp-feedback-form--content-form-textarea'
            }
            value={this.state.comments}
            onChange={e => this.handleCommentsChange(e.target.value)}
            rows={8}
            required={true}
          />
          {this.feedBackErrors?.commentsRequiredError ? (
            <React.Fragment>
              <div className="rp-input-error">
                {t('common.fieldRequiredTxt')}
              </div>
            </React.Fragment>
          ) : (
            ''
          )}

          <div className="rp-feedback-action-btn-container">
            <input
              type="button"
              value={t('feedbackForm.submitFeedback')}
              onClick={this.handleSubbmit}
              className="primary-button rp-feedback-form--content-form-button"
              disabled={this.state.loading}
            />
          </div>
        </form>
      </React.Fragment>
    );
  }

  private renderThankYou() {
    const { t } = this.props;
    return (
      <div className="rp-feedback-form--content-thankyou">
        <p>{t('feedbackForm.thanksForFeedback')}</p>
        <button
          className="secondary-button rp-feedback-form--content-form-button"
          onClick={this.props.onClose}
        >
          {(t('common.close') as string).toUpperCase()}
        </button>
      </div>
    );
  }

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-feedback-form" style={this.state.style}>
        {this.state.isMobile ? (
          <div className="rp-feedback-form--mobile">
            <div
              onClick={e => this.closeModal()}
              className="rp-feedback-form--mobile-cancel"
            >
              <span className="rpds-close cancel-icon" />
              {t('common.cancel')}
            </div>
            {this.renderFeedbackForm()}
          </div>
        ) : (
          <Modal handleCloseModal={() => this.closeModal()}>
            {this.renderFeedbackForm()}
          </Modal>
        )}
      </div>
    );
  }
}

export default FeedbackForm;

function FeedBackFormErrors() {
  return {
    nameRequiredError: false,
    emailRequiredError: false,
    accountNumberRequiredError: false,
    commentsRequiredError: false,
    invalidEmailError: false,
    invalidAccountNumberError: false,
    subjectRequiredError: false,
    invalidPhoneNumber: false,
    isFieldsRequiredError() {
      return (
        this.nameRequiredError ||
        this.emailRequiredError ||
        this.accountNumberRequiredError ||
        this.commentsRequiredError
      );
    }
  };
}
